// extracted by mini-css-extract-plugin
export default {"poweredByGoogle":"SearchAddressModal_poweredByGoogle__kxh2p"};